import { fetchCampaignQuickRepliesQuery } from 'api/queries';
import { useTimeFiltersContext } from 'modules/campaignAnalytics/context';
import { selectTemplateId } from 'modules/campaignAnalytics/selectors';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { useGraphql } from 'utils/hooks/useGraphql';
import { getUrlParams } from 'utils/urlParams';
import { CampaignQuickRepliesResultsDefinition } from './types';

export const useCampaignQuickReplies = (locale?: string) => {
  const { search } = useLocation();
  const { campaignId } = getUrlParams(search);
  const templateId = useSelector(selectTemplateId);
  const { dateParams } = useTimeFiltersContext();
  const { startTime, endTime } = dateParams || {};

  return useGraphql<{ campaignQuickReplies: CampaignQuickRepliesResultsDefinition }>(
    fetchCampaignQuickRepliesQuery,
    {
      skip: !campaignId || !templateId || !startTime || !endTime,
      fetchPolicy: 'cache-and-network',
      variables: {
        campaignId: Number(campaignId),
        startTime: startTime?.toISOString(),
        endTime: endTime?.toISOString(),
        templateId: Number(templateId),
        locale,
      },
    },
  );
};
